import { Button, ButtonGroup, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ImageList, ImageListItem, ImageListItemBar, IconButton } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DescriptionIcon from '@mui/icons-material/Description';
import PhotoIcon from '@mui/icons-material/Photo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PropTypes from 'prop-types';
import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';




const styles = {
  root: {},
  dropZone: (theme) => ({
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: colors.grey[50],
      opacity: 0.5,
      cursor: 'pointer'
    }
  }),
  dragActive: {
    backgroundColor: colors.grey[50],
    opacity: 0.5
  },
  info: (theme) => ({
    marginTop: theme.spacing(1)
  }),
  list: {
    maxHeight: 320
  },
  actions: (theme) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  }),
  icon: {
    color: 'white',
  },
  image: (theme) => ({
    position: 'relative',
    height: 130,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  }),
  focusVisible: {},
  imageButton: (theme) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  }),
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: (theme) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
  }),
  imageTitle: (theme) => ({
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  }),
  imageMarked: (theme) => ({
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  }),
  imageFull: (theme) => ({
    marginTop: theme.spacing(2),
    width: '100%'
  }),
};

function FilesPreview({ className, FisNo, dataUri, files, readonly, setUploadingFile, setLoading, issondaj = 0 }) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
 
  const handleDetayAc = (event,dosya) => {
    setLoading(true);
    var FileData = `data:${dosya.MIMEType};base64,${dosya.FileData}`
    if (dosya?.MIMEType?.includes('image')) {
      var image = new Image();
      image.src = FileData;
      var w = window.open("");
      if (!w) {
        return;
      }
      w.document.write(image.outerHTML);
      w.document.title = dosya.Title;
      w.document.close();
    } else {
      var blobData = base64ToBlob(dosya.FileData, "application/pdf");
      openBlobInNewTab(blobData);
    }
    setLoading(false);
  }

  function base64ToBlob(base64Data, contentType) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
  function openBlobInNewTab(blobData) {
    var newTab = window.open();
    if (!newTab) {
      return;
    }
    var objectUrl = URL.createObjectURL(blobData);
    newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
  }





  const handleDelete = (event,fileId) => {
    debugger
    const data = files.filter((item) => item.Title != fileId)
    setUploadingFile(data && data.length > 0 ? data : []);
    
}

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div
      style={styles.root}
      className={className}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {files.length > 0 && (
        <>
          <ImageList sx={styles.gridList}>
            {files.map((tile) => (
              <ImageListItem
                key={tile.DOSYA_ID}
              >
                <IconButton
                  onClick={(event) => handleDetayAc(event, tile)} aria-label={`büyük resim ${tile.Title}`}
                >
                  {
                    (tile.MIMEType === 'image/jpeg' || tile.MIMEType === 'image/png' || tile.MIMEType === 'image/gif')
                      ?
                      <PhotoIcon fontSize='large' sx={styles.imageFull} />
                      :
                      (
                        tile.MIMEType === 'application/pdf' ? <PictureAsPdfIcon fontSize='large' /> : <DescriptionIcon fontSize='large' />
                      )
                  }
                </IconButton>
                <ImageListItemBar
                  title={tile.Title}
                  subtitle={<span>{(tile.DOSYA_ID < 0 ? ' Lokal' : '')}</span>}
                  actionIcon={
                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                      <IconButton onClick={(event) => handleDelete(event, tile.Title)}
                        aria-label={`Delete ${tile.Title}`}
                        sx={styles.icon}
                        disabled={readonly}
                      >
                        <DeleteForeverIcon color="error" />
                      </IconButton>
                    </ButtonGroup>
                  }
                />
              </ImageListItem>
            ))}
          </ImageList>
        </>
      )}
    </div>
  );
}
FilesPreview.propTypes = {
  className: PropTypes.string
};

export default FilesPreview;
